import React, { FC } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { Button, ButtonSize, ButtonColor } from '@code/innovance-react-ui-kit';

import { Container, FormRow, Title } from 'src/front/components/FormStyles';
import AsyncButton from 'src/front/components/AsyncButton';

import { DASHBOARD } from 'src/front/routes/paths';

import { ScoringResultType } from 'src/front/api/generated';

import successIcon from 'src/front/assets/icon_success.svg';
import rejectIcon from 'src/front/assets/icon_reject.svg';

const SuccessContainer = styled.div`
  display: flex;
`;

const RejectContainer = styled.div`
  display: flex;
`;

export const ButtonRow = styled.div`
  display: flex;
  margin: 10px 0;
  justify-content: flex-start;
`;

const PrintButton = styled(Button)`
  margin-right: 20px;
`;

interface LocationStates {
  message: string;
  status?: ScoringResultType;
  onRepeat: () => void;
}

const CardSuccess: FC = () => {
  const { t } = useTranslation();
  const { state } = useLocation<LocationStates>();
  const history = useHistory();

  const goToHome = (): void => history.push(DASHBOARD);
  const isApproved = state.status === ScoringResultType.AUTOAPPROVE;

  return (
    <Container>
      {isApproved ? (
        <SuccessContainer>
          <img alt="Success icon" src={successIcon} />
        </SuccessContainer>
      ) : (
        <RejectContainer>
          <img alt="Reject icon" src={rejectIcon} />
        </RejectContainer>
      )}
      <Title>
        <Trans
          i18nKey={
            isApproved ? 'cardEntry_appsuccess_success_text' : 'cardEntry_appresult_reject_text'
          }
        />
      </Title>
      <FormRow>{state.message}</FormRow>

      <ButtonRow>
        <PrintButton
          color={ButtonColor.Secondary}
          onClick={goToHome}
          size={ButtonSize.Medium}
          text={t('general_components_leftMenu_dashboard_label')}
          type="button"
        />
        {isApproved ? (
          <AsyncButton
            color={ButtonColor.Primary}
            onClick={state.onRepeat}
            size={ButtonSize.Medium}
            text={t('general_components_repeat_button')}
            type="button"
          />
        ) : null}
      </ButtonRow>
    </Container>
  );
};

export default CardSuccess;
